import React from 'react';

import { CheckedImage, HourglassImage, UploadImage, VerifyImage } from 'assets/icons';

import styles from './InformationBoxWithBubble.module.scss';

const VERIFY_TEXT =
  'Verify Now - The FASTEST way to get your loan processed.  Simply login to your Income Source (payroll provider, benefits, employer, etc.).';
const UPLOAD_TEXT = 'Upload – Please drag the required files to the designated label or just click ‘upload’';
const RECEIVED_TEXT =
  'Received – Your upload has been received. Please allow me up to 48 business hours to review your upload(s) for accuracy';
const COMPLETED_TEXT =
  'Completed – HFS has reviewed and accepted the required document upload. Once all items are marked completed, we will move your file to underwriting';

const VerificationBoxPrompt = () => {
  return (
    <>
      <div className={styles.boxHeader}>Status Legend</div>
      <div className={styles.infoStatusRow}>
        <VerifyImage />
        {VERIFY_TEXT}
      </div>
      <div className={styles.infoStatusRow}>
        <UploadImage />
        {UPLOAD_TEXT}
      </div>
      <div className={styles.infoStatusRow}>
        <HourglassImage />
        {RECEIVED_TEXT}
      </div>
      <div className={styles.infoStatusRow}>
        <CheckedImage />
        {COMPLETED_TEXT}
      </div>
    </>
  );
};

export default VerificationBoxPrompt;
